/**
 * @param {Array<{status: string, round?: number, agreedPrice?: number|string, currency?: string, createdAt?: string|Date}>} collabs
 * @returns {{amount: number, currency: string} | null}
 */
export function displayPrice (collabs) {
  if (!collabs || !collabs.length) return null;

  const active = collabs.filter(c => c.status === 'IN_PROGRESS' && c.agreedPrice);
  if (active.length) {
    const winner = active.reduce((a, b) => (a.round || 0) >= (b.round || 0) ? a : b);
    return { amount: Number(winner.agreedPrice), currency: winner.currency || 'USD' };
  }

  const withPrice = collabs.filter(c => c.agreedPrice && c.createdAt);
  if (!withPrice.length) return null;
  const latest = [...withPrice].sort((a, b) =>
    new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )[0];
  if (latest?.agreedPrice) {
    return { amount: Number(latest.agreedPrice), currency: latest.currency || 'USD' };
  }

  return null;
}
